<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->
<div class="carousel-container">
	<button class="carousel-arrows" (click)="selectPreviousSlide()" *ngIf="slides.length > 1">
		<span class="material-icons"> chevron_left </span>
	</button>
	<div class="slide-view" [ngStyle]="{ 'width.px': width, 'height.px': height }">
		<div [ngStyle]="{ transform: 'translateX(' + xPosition + 'px)' }">
			<ng-content></ng-content>
		</div>
	</div>
	<button class="carousel-arrows" (click)="selectNextSlide()" *ngIf="slides.length > 1">
		<span class="material-icons"> chevron_right </span>
	</button>
</div>
